import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { formatBalance as m } from "../../../utils/formatNumber.js";
import { cn as b } from "../../../lib.js";
import N from "../../../components/common/TokenPrice.js";
import { s as S } from "../../../shallow-27fd7e97.js";
import i from "../../../store/useStore.js";
import n from "../../../components/ui/tooltipDialog.js";
import "../../../extend-tailwind-merge-e63b2b56.js";
import "../../../utils/formatToken.js";
import "react";
import "../../../lib/utils.js";
import "../../../trends/components/PriceFormatter.js";
import "../../../_commonjsHelpers-10dfc225.js";
import "../../../index-9d43cc8b.js";
import "../../../store/createTokenSearchSlice.js";
import "../../../immer-548168ec.js";
import "../../../store/createWalletSlice.js";
import "../../../store/createSwapSettingsSlice.js";
import "../../../store/createGlobalSettingsSlice.js";
import "../../../store/createUserOrdersSlice.js";
import "../../../store/createSwapSlice.js";
import "../../../store/createChartSlice.js";
import "../../../store/createBasketSlice.js";
import "../tokens.js";
import "../../../store/createModalWhatsNewSlice.js";
import "../../../store/createSwapParamsSlice.js";
import "../../../hooks/useScreen.js";
import "../../../components/ui/dialog.js";
import "../../../index-840f2930.js";
import "../../../index-1c873780.js";
import "../../../index-c7156e07.js";
import "../../../index-563d1ed8.js";
import "../../../index-4914f99c.js";
import "../../../index-67500cd3.js";
import "../../../index-c8f2666b.js";
import "../../../index-27cadef5.js";
import "../../../index-5116e957.js";
import "../../../components/ui/tooltip.js";
import "../../../index-0ce202b9.js";
import "../../../index-bcfeaad9.js";
import "../../../index-f7426637.js";
const hs = () => {
  const { swapDetails: s, tokenBuy: d, tokenSell: a, bonusOutput: h, inputMode: p } = i(
    (e) => ({
      swapDetails: e.swapSlice.swapDetails,
      tokenBuy: e.swapSlice.tokenBuy,
      tokenSell: e.swapSlice.tokenSell,
      bonusOutput: e.swapSlice.bonusOutput,
      inputMode: e.swapSlice.inputMode
    }),
    S
  ), { swapType: l } = i((e) => e.tokenSearchSlice), { slippage: x } = i((e) => e.swapSettingsSlice), { isPricesFlipped: c, setIsPricesFlipped: g } = i(
    (e) => e.globalSettingsSlice
  ), f = s.splits.length > 1, r = s.deposits, u = s.splits.reduce((e, T) => e + T.fee / 1e6, 0), R = p === "SELL" ? s.net_price : (
    // [NOTE]: temporary fix, need backend fix
    ((s == null ? void 0 : s.total_input) - (s == null ? void 0 : s.total_input) * (x / 100) - (s == null ? void 0 : s.batcher_fee) - (s == null ? void 0 : s.partner_fee)) / (s == null ? void 0 : s.total_output)
  );
  return /* @__PURE__ */ o(
    "div",
    {
      className: b(
        "dhs-grid @md/appRoot:dhs-grid-cols-3 dhs-grid-cols-[1fr_110px] @md/appRoot:dhs-gap-2.5 dhs-gap-x-2.5 dhs-leading-normal dhs-font-proximaMedium"
      ),
      children: [
        /* @__PURE__ */ o("div", { className: "dhs-col-span-1 dhs-flex dhs-flex-col dhs-items-start sm:dhs-gap-[2px]", children: [
          /* @__PURE__ */ t(
            n,
            {
              trigger: /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-semibold sm:dhs-font-proximaRegular", children: "Bonus Output" }),
              content: `The aggregator bonus is the extra amount of tokens you get when using an aggregator
        instead of a single dex.`,
              contentClass: "dhs-text-mainText"
            }
          ),
          f ? /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-success dhs-font-bold", children: h }) : /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-mainText sm:dhs-text-sm dhs-leading-none", children: "Direct Swap" })
        ] }),
        /* @__PURE__ */ o("div", { className: "dhs-col-span-1 sm:dhs-order-3 dhs-flex dhs-flex-col dhs-items-start sm:dhs-gap-[2px]", children: [
          /* @__PURE__ */ t(
            n,
            {
              trigger: /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-semibold sm:dhs-font-proximaRegular", children: "Net price" }),
              content: "The net price is the average price you get for your tokens after the fees.",
              contentClass: "dhs-text-mainText"
            }
          ),
          /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-mainText sm:dhs-text-sm dhs-leading-none", children: /* @__PURE__ */ t(
            N,
            {
              tokenPrice: R,
              tokenBuyTicker: d == null ? void 0 : d.ticker,
              tokenSellTicker: a == null ? void 0 : a.ticker,
              isReverse: l === "BUY",
              onClick: () => g(!c)
            }
          ) })
        ] }),
        /* @__PURE__ */ o("div", { className: "dhs-col-span-1 sm:dhs-order-5 dhs-flex dhs-flex-col dhs-items-start sm:dhs-gap-[2px]", children: [
          /* @__PURE__ */ t(
            n,
            {
              trigger: /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-semibold sm:dhs-font-proximaRegular", children: "Min. receive" }),
              content: "The minimum amount of tokens you will receive after the fees.",
              contentClass: "dhs-text-mainTex dhs-w-[250px]",
              side: "bottom"
            }
          ),
          /* @__PURE__ */ o("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-mainText sm:dhs-text-sm dhs-leading-none", children: [
            m(s.total_output),
            " ",
            d == null ? void 0 : d.ticker
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "dhs-col-span-1  sm:dhs-order-6 dhs-flex dhs-flex-col dhs-items-start sm:dhs-gap-[2px]", children: [
          /* @__PURE__ */ t(
            n,
            {
              trigger: /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-semibold sm:dhs-font-proximaRegular", children: "Order Deposits" }),
              content: /* @__PURE__ */ t("span", { children: "When your orders are processed or cancelled, this amount of ADA will be returned." }),
              contentClass: "dhs-text-mainText dhs-flex dhs-flex-col"
            }
          ),
          /* @__PURE__ */ o("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-mainText sm:dhs-text-sm dhs-leading-none", children: [
            m(r),
            " ADA"
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "dhs-col-span-1 sm:dhs-order-4 dhs-flex dhs-flex-col dhs-items-start sm:dhs-gap-[2px]", children: [
          /* @__PURE__ */ t(
            n,
            {
              trigger: /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-semibold sm:dhs-font-proximaRegular", children: "Batchers fees" }),
              content: "Total batcher fees paid to the dexes.",
              contentClass: "dhs-text-mainText"
            }
          ),
          /* @__PURE__ */ o("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-mainText sm:dhs-text-sm dhs-leading-none", children: [
            m(u - r),
            " ADA"
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "dhs-col-span-1 sm:dhs-order-2 dhs-flex dhs-flex-col dhs-items-start sm:dhs-gap-[2px]", children: [
          /* @__PURE__ */ t(
            n,
            {
              trigger: /* @__PURE__ */ t("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-semibold sm:dhs-font-proximaRegular", children: "Frontend Fee" }),
              content: "The DexHunter fee is the fee paid to DexHunter for the service.",
              contentClass: "dhs-text-mainText dhs-w-[250px]"
            }
          ),
          /* @__PURE__ */ o("span", { className: "dhs-text-xs @sm/appRoot:dhs-text-sm @md/appRoot:dhs-text-md dhs-text-mainText sm:dhs-text-sm dhs-leading-none", children: [
            m(s.partner_fee),
            " ADA"
          ] })
        ] })
      ]
    }
  );
};
export {
  hs as default
};
